import React from 'react'
import { GrcTable, GrcTableBody, GrcTableCell, GrcTableContainer, GrcTableHead, GrcTableHeadRow, GrcTableRow } from '../../Common/ui/TableComponent'

import Tooltip from '@mui/material/Tooltip'

import { t } from 'i18next'

import ContentCircle from 'src/Common/ui/contentCircle'

import { TableCell } from '@mui/material'
import { Checkbox } from 'src/Common/ui/checkbox'
import { typeBodyCompCondition } from 'src/Entities/TransferEntities'

export default function TransferComplianceTable ({
    type,
    selectAll, handleSelectAll, sortFilter, paginatedData, handleTypeClick, handleSelectChecked, transferTableSearchValue, filteredRegulationData
    , currentPage
    , rowsPerPage
}) {
    return (
        <>
            <GrcTableContainer>
                <GrcTable>
                    <GrcTableHead>
                        <GrcTableHeadRow>
                            <GrcTableCell className="col-sticky" sx={{ minWidth: '40px', left: 0, zIndex: 1 }}>
                                <div className='flex justify-between'>
                                    <Tooltip title="Select all" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}><div className='mr-1'>
                                        <Checkbox
                                            checked={selectAll}
                                            onCheckedChange={(event) => handleSelectAll(event)}
                                            borderColor='text-primary'
                                        />
                                    </div>
                                    </Tooltip>
                                </div>
                            </GrcTableCell>

                            <GrcTableCell className="col-sticky" sx={{ minWidth: '40px', left: 47, zIndex: 1 }}>
                                <Tooltip title="S.No" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                       #
                                    {/* <Tooltip title="Sort" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}></Tooltip> */}
                                </Tooltip>
                            </GrcTableCell>

                            <GrcTableCell className="col-sticky" sx={{ minWidth: '24rem', left: 92, zIndex: 2 }}>
                            Regulation
                                <Tooltip title="Sort" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <img onClick={() => sortFilter('regulationName')} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/sortIcon.svg' /></Tooltip>
                            </GrcTableCell>

                            <GrcTableCell className="col-sticky" sx={{ minWidth: '100px', zIndex: 1 }}>
                            Compliance
                                <Tooltip title="Sort" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <img onClick={() => sortFilter('complianceTitle')} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/sortIcon.svg' /></Tooltip>
                            </GrcTableCell>

                            <GrcTableCell sx={{ minWidth: '180px' }}>
                            Frequency
                                <Tooltip title="Filter" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <img onClick={handleTypeClick} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/FunnelFilter.svg' /></Tooltip>
                            </GrcTableCell>
                        </GrcTableHeadRow>
                    </GrcTableHead>
                    <GrcTableBody>
                        {filteredRegulationData.filter(ele => ele.complianceTitle?.toLowerCase().includes(transferTableSearchValue))?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage).length > 0
                            ? (filteredRegulationData.filter(ele => ele?.complianceTitle?.toLowerCase().includes(transferTableSearchValue))?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)?.map((item, indexx) =>
                                <GrcTableRow key={indexx}>
                                    <GrcTableCell className='sticky' sx={{ minWidth: '40px', left: 0, zIndex: 1 }}>
                                        <Checkbox
                                            checked={item?.checkbox}
                                            onCheckedChange={(event) => handleSelectChecked(item.id)}
                                            borderColor='text-primary'
                                        />
                                    </GrcTableCell>
                                    <GrcTableCell className="col-sticky-td" sx={{ minWidth: '40px', left: 47, zIndex: 1 }}>
                                        <div className='flex justify-between items-center'>
                                            { <ContentCircle className='min-h-6 min-w-6 bg-[hsl(var(--primary-thick-foreground))]' contentClassName={'text-primary'} content={(currentPage - 1) * rowsPerPage + indexx + 1}/>
                                            }
                                        </div>
                                    </GrcTableCell>
                                    <GrcTableCell className="col-sticky-td  cursor-pointer" sx={{ minWidth: '24rem', left: 92, zIndex: 2 }}>{item.regulationName}</GrcTableCell>
                                    <GrcTableCell className="col-sticky-td  cursor-pointer" sx={{ minWidth: '24rem', left: 92, zIndex: 1 }}>{item.complianceTitle}</GrcTableCell>
                                    <GrcTableCell className="col-sticky-td  cursor-pointer" sx={{ minWidth: '24rem', left: 92, zIndex: 1 }}>{item.frequencyName}</GrcTableCell>

                                </GrcTableRow>
                            ))
                            : transferTableSearchValue?.length > 0
                                ? <GrcTableRow>
                                    <TableCell colSpan={8} align='center'>{t('No Data Found')}</TableCell>
                                </GrcTableRow>
                                : <GrcTableRow>
                                    <TableCell colSpan={8} align='center'>{t(typeBodyCompCondition(type) ? 'No Data Found' : 'Select the dropdown to view compliance against the respective department.')}</TableCell>
                                </GrcTableRow>
                        }
                    </GrcTableBody>

                </GrcTable>
            </GrcTableContainer>
        </>
    )
}
